export { default } from './SendSummaryCard';
